<template>
  <b-modal
    id="change-password-modal"
    ref="modal"
    centered
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Validate')"
    :title="$t('user.update.password')"
    cancel-variant="outline-primary"
    @hidden="resetModal"
    @ok="handleOk"
    @show="resetModal">

    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-form-group
        :invalid-feedback="newPassword.invalidFeedback"
        :label="$t('NewPassword')"
        :state="newPassword.state"
        label-for="newPassword-input">
        <div class="password-line">
          <b-form-input
            id="newPassword-input"
            v-model="newPassword.value"
            :state="newPassword.state"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="off"
            required>
          </b-form-input>
          <b-button variant="light" @click="togglePassword">
            <eye-icon v-if="!showPassword"></eye-icon>
            <eye-off-icon v-else></eye-off-icon>
          </b-button>
        </div>
      </b-form-group>

    </form>
  </b-modal>
</template>

<script>
import api from '../../services/api'
import {mapActions} from 'vuex'


export default {

  name: 'change-password-modal',
  props: {
    isFirstConnexion: {
      default: false
    }
  },

  data: function () {
    return {
      showPassword: false,
      oldPassword: {
        value: null,
        state: null,
        invalidFeedback: null
      },
      newPassword: {
        value: null,
        state: null,
        invalidFeedback: null
      },
      newPasswordRepeat: {
        value: null,
        state: null,
        invalidFeedback: null
      }
    }
  },

  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword
    },

    ...mapActions(['LogIn']),

    resetModal() {
      this.oldPassword.value = null
      this.oldPassword.state = null
      this.oldPassword.invalidFeedback = null
      this.newPassword.value = null
      this.newPassword.state = null
      this.newPassword.invalidFeedback = null
      this.newPasswordRepeat.value = null
      this.newPasswordRepeat.state = null
      this.newPasswordRepeat.invalidFeedback = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('newPassword', this.newPassword.value.trim())

      api({
        method: 'POST',
        url: `/user/updateCurrentUserPassword`,
        data: formData
      })
        .then(() => {
          let data = {
            username: this.$store.getters.username,
            password: this.newPassword.value.trim()
          }

          this.LogIn(data)

          this.resetModal()
          this.hideModal()
          this.successToast()
        })
        .catch(() => {
          this.errorToast()
        })
    },

    hideModal() {
      this.$bvModal.hide('change-password-modal')
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }

      if (this.newPassword.value == null || this.newPassword.value.trim() === '') {
        this.newPassword.state = false
        this.newPassword.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.newPassword.value.trim().length < 8) {
        this.newPassword.state = false
        this.newPassword.invalidFeedback = this.$i18n.t('Password.minlenght.error')
        return false
      }
      return true
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('ChangePassword.success'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    },

    errorToast() {
      this.oldPassword.state = false
      this.oldPassword.invalidFeedback = this.$i18n.t('incorrect.password')
      this.$bvToast.toast(this.$i18n.t('password.error'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>
.password-line {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/views/user/ChangePasswordModal.vue